module.exports = __webpack_public_path__ + "static/gallery-img-9-41d1bc3bde0dc3a54325689927520995.jpg";